/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「文字输入框」
 * @modify Date:2021.2.17 15:22
 */
<template>
  <div class="cTextInput-container">
    <input
      type="text"
      autocapitalize="off"
      autocorrect="off"
      :maxlength="maxlength ? maxlength : '200'"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="value"
      :class="{ error: formatError, inputEdited: value }"
      @blur="handleblur"
      @focus="handleComposing"
      @input="$emit('input', $event.target.value.trim())"
      v-disable-emoji-input
      :style="inputStyle"
    />
    <p v-if="formatError" class="inputMessage" v-html="$sanitize(message)"></p>
  </div>
</template>

<script>
export default {
  name: 'InputItem',
  props: [
    'value',
    'placeholder', //提示信息
    'message', //错误信息
    'formatError',
    'disabled',
    'onkeypress',
    'maxlength',
    'inputStyle'
  ],
  data() {
    return {};
  },
  methods: {
    //正在输入
    handleComposing() {
      this.$emit('update:formatError', false);
    },
    // 失去焦点，校验信息
    handleblur() {
      this.$emit('blur');
    }
  }
};
</script>
<style scoped lang="less">
.cTextInput-container {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;
  input {
    height: 0.5rem;
    background: var(--bg-pinkcolor);
    border: 2px solid var(--maincolor);
    font-size: 0.16rem;
    line-height: 0.5rem;
    color: var(--text-graycolor);
    padding: 0 0.14rem;
    width: 100%;
    border-radius: 5px;
  }
  .inputEdited {
    background-color: #ffffff;
    color: #333333;
  }
  .error {
    border: 1px solid red;
  }
  .inputMessage {
    padding: 0 0.05rem;
    color: red;
    font-size: 0.12rem;
    line-height: 0.14rem;
    min-height: 0.28rem;
    white-space: pre-wrap;
    margin-top: 0.05rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/cTextInput.vue